function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import classNames from 'classnames';
import './IconBase.css';
import whitelistProps from '../../utils/whitelistProps';
var whitelist = whitelistProps();
export default function Icon(_ref) {
  var _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? '0 0 16 16' : _ref$viewBox,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 16 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 16 : _ref$height,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    transform = _ref.transform,
    attrs = _objectWithoutProperties(_ref, ["viewBox", "width", "height", "children", "className", "transform"]);
  return /*#__PURE__*/React.createElement("span", Object.assign({
    className: classNames('_dm-icon', _defineProperty({
      '_dm-icon--base': !className
    }, className, className))
  }, whitelist(attrs)), /*#__PURE__*/React.createElement("svg", {
    className: "_dm-svg",
    viewBox: viewBox,
    version: "1.1",
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    transform: transform
  }, children));
}